import React, { createContext, useContext } from 'react';
const PortalCreateContext = /*#__PURE__*/createContext(undefined);
export const PortalCreateContextProvider = ({
  KbSuggestionField,
  children
}) => {
  return /*#__PURE__*/React.createElement(PortalCreateContext.Provider, {
    value: {
      KbSuggestionField: KbSuggestionField
    }
  }, children);
};
export function usePortalCreateContext() {
  var _portalCreateContextD;
  const portalCreateContextData = useContext(PortalCreateContext);
  return {
    KbSuggestionField: (_portalCreateContextD = portalCreateContextData === null || portalCreateContextData === void 0 ? void 0 : portalCreateContextData.KbSuggestionField) !== null && _portalCreateContextD !== void 0 ? _portalCreateContextD : undefined
  };
}